
export class SearchOpeCriteria {

    motCle!: string;
    //region!: string[];
    region!: string;
    codesDepartement: string[]=[];
    //villes!: string[];
    villes!: string;
    //Appartement maison
    //codeCategories!: BigInteger[];
    codeCategories!: number;
    //T1 T2 ....
    //codeTypologie!: BigInteger[];
    codeTypologie!: number;
    //Tyepologie
    nbrPieces!: number;
    etage!: string;
    surfaceExterne!: boolean;
    budget!: number[];
    nbmoisLivraison!: number[];
    //codeTva!: string[];
    codeTva!: number;
    //statutLot!: BigInteger[];
    statutLot!: number;

    

}


